<template>
  <div v-loading="loading" element-loading-text="菜单加载中，请稍候..."
       :class="['panel', 'panel-menu', showLeftMenu || 'panel-hide']">
    <div ref="leftMenuHead" class="panel-head">
      <div class="panel-search">
        <div class="form-con form-transparent">
          <div class="input-wrap input-hasicon input-hasappend">
            <span class="input-icon"><i class="mng icon-zoom" @click="handleShowIcon"></i></span>
            <input type="text"
                   ref="searchInput"
                   placeholder="搜索"
                   class="form-control"
                   v-model.trim="menuSearchInputVal"
                   @focus="handleTreeSearchInputFocusAndBlur(true)"
                   @blur="handleTreeSearchInputFocusAndBlur(false)">
            <div class="input-append"
                 v-if="menuSearchInputVal"
                 @click="clearSearchInputVal">
              <a class="btn clear"><i class="mng icon-cross-stroke"></i></a>
            </div>
          </div>
        </div>
      </div>
      <div class="panel-control">
        <el-tooltip :openDelay="200" effect="dark" :content="!treeAllNodeExpend?'全部展开':'全部收起'" placement="right">
          <a href="javascript:;" @click="handleTreeExpend" class="tree-control-btn"
             :class="{'active':treeAllNodeExpend}">
            <i class="mng icon-tree-unfold"></i>
          </a>
        </el-tooltip>
      </div>
    </div>
    <el-scrollbar class="whaty-menu-scroll" ref="leftMenuScrollBar" :style="{'height': treeContainerHeight + 'px'}"
                  style="width: 100%">
      <div class="panel-menu">
        <template>
          <el-menu
            text-color="#fff"
            active-text-color="#fff"
            :popper-append-to-body="false"
            :default-openeds="menuOpens"
            :default-active="currentNodeId"
            :collapse-transition="false"
            :collapse="!showLeftMenu">
            <template v-for="(node, i)  in treeData" v-show="node.show === undefined || node.show">
              <template v-if="!node.children || node.children.length === 0">
                <!-- 只有一级菜单 -->
                <el-menu-item :index="node.routerName || node.id"
                              v-show="node.show === undefined || node.show"
                              :data="node.routerName || node.id"
                              :key="node.id"
                              @click="handleTreeNodeClick(node)">
                  <div class="icon"><i :class="['mng', node.icon || 'icon-tree-files-stroke']"></i></div>
                  <span class="title first-level-title" slot="title">{{ node.name }}</span>
                </el-menu-item>
              </template>
              <!-- 一级菜单，有二级菜单的 -->
              <div v-if="node.children && node.children.length > 0">
                <el-submenu :index="node.id" v-show="node.show === undefined || node.show" :key="i" popper-class="panel-collapse-cell">
                  <template slot="title">
                    <div class="icon"><i :class="['mng', node.icon || 'icon-tree-files-stroke']"></i></div>
                    <span class="title first-level-title" slot="title" v-show="showLeftMenu">{{ node.name }}</span>
                  </template>
                  <template v-for="(item, j) in node.children" v-show="item.show === undefined || item.show">
                    <!-- 只有二级菜单 -->
                    <template v-if="!item.children || item.children.length === 0">
                      <el-menu-item :index="item.routerName || item.id"
                                    v-show="item.show === undefined || item.show"
                                    :data="item"
                                    :key="item.id"
                                    @click="handleTreeNodeClick(item)">
                        <div class="arrow"><i class="mng icon-arrow-right-fill"></i></div>
                        <div class="icon icon-sm"><i style="font-size: 16px" class="mng icon-tree-file-stroke"></i></div>
                        <span class="title" slot="title">{{ item.name }}</span>
                      </el-menu-item>
                    </template>
                    <!-- 带有三级菜单的二级菜单 -->
                    <template v-if="item.children && item.children.length > 0">
                      <el-submenu :index="item.routerName || item.id" v-show="item.show === undefined || item.show" :data="item" :key="j">
                        <template slot="title" class="title">
                          <div class="arrow"><i class="mng icon-arrow-right-fill"></i></div>
                          <div class="icon icon-sm"><i style="font-size: 16px" class="mng mng icon-tree-file-stroke"></i></div>
                          <span class="title" slot="title">{{ item.name }}</span>
                        </template>
                        <template v-for="(data, k) in item.children" v-show="data.show === undefined || data.show">
                          <!-- 只有三级菜单 -->
                          <template v-if="!data.children || data.children.length === 0">
                            <el-menu-item :index="data.routerName || data.id"
                                          v-show="data.show === undefined || data.show"
                                          :data="data"
                                          :key="data.id"
                                          @click="handleTreeNodeClick(data)">
                              <div class="arrow"><i class="mng icon-arrow-right-fill"></i></div>
                              <div class="icon icon-sm"><i class="mng icon-filenull-stroke"></i></div>
                              <span class="title" slot="title">{{ data.name }}</span>
                            </el-menu-item>
                          </template>
                          <!-- 带有四级菜单的三级菜单 -->
                          <template v-if="data.children && data.children.length > 0">
                            <el-submenu :index="data.routerName || data.id" v-show="data.show === undefined || data.show" :data="data" :key="k">
                              <template slot="title" class="title">
                                <div class="arrow"><i class="mng icon-arrow-right-fill"></i></div>
                                <div class="icon icon-sm"><i style="font-size: 16px" class="mng mng icon-tree-file-stroke"></i></div>
                                <span class="title" slot="title">{{ data.name }}</span>
                              </template>
                              <el-menu-item :index="fourNode.routerName || fourNode.id"
                                            v-for="(fourNode, l) in data.children"
                                            v-show="fourNode.show === undefined || fourNode.show"
                                            :data="fourNode"
                                            :key="fourNode.id"
                                            @click="handleTreeNodeClick(fourNode)">
                                <div class="arrow"><i class="mng icon-arrow-right-fill"></i></div>
                                <div class="icon icon-sm"><i class="mng icon-filenull-stroke"></i></div>
                                <span class="title" slot="title">{{ fourNode.name }}</span>
                              </el-menu-item>
                            </el-submenu>
                          </template>
                        </template>
                      </el-submenu>
                    </template>
                  </template>
                </el-submenu>
              </div>
            </template>

          </el-menu>
        </template>
      </div>
    </el-scrollbar>
    <!----------- tree end ---------->
    <div class="pannel-foot">
      <el-tooltip :class="['item', showLeftMenu || 'active']" effect="dark"
                  :content="(showLeftMenu ? '隐藏' : '显示') + '侧边栏'" placement="right">
        <a href="javascript:;" @click="handleShowLeftMenu(!showLeftMenu)" class="pannel-trigger"><i class="mng icon-sidefold"></i></a>
      </el-tooltip>
    </div>
  </div>
</template>
<script>
import {STORE_APP_MUTATION_TYPES} from '../../libs/constants'
import SubTreeRow from './sub-tree-row.vue'
import util from '../../libs/util'

let _ = require('lodash')

export default {
  components: {SubTreeRow},
  name: 'left-menu',
  data() {
    return {
      treeData: [],
      loading: true,
      treeContainerHeight: 200, // 菜单区域高度
      menuSearchInputVal: '', // 菜单搜索框输入内容
      treeSearchInputFocus: false, // 菜单搜索框获取焦点标志
      treeAllNodeExpend: false, // 菜单全部展开标志
      foldImgPath: 'static/styles/images/fold.png',
      unFoldImgPath: 'static/styles/images/unfold.png',
      menuOpens: [] // 菜单默认打开数组
    }
  },
  computed: {
    currentNodeId: function () {
      return this.$store.state.app.currentLeftMenuId
    },
    showLeftMenu: function () {
      return this.$store.state.app.showLeftMenu
    }
  },
  created() {
  },
  mounted() {
    this.loadTreeData()
    this.treeContainerAutoHeight()
  },
  methods: {
    loadTreeData() { // 加载菜单数据
      this.$store.dispatch('GetMenuTree').then(data => { // 拉取权限
        this.treeData = data
        this.loading = false
        // 判断是否有默认menu，有则打开
        let defaultMenu = this.$store.state.app.defaultMenu
        if (defaultMenu.id) {
          this.handleTreeNodeClick(defaultMenu)
        }
      }).catch((e) => {
        console.error(e)
        this.$notify.error({title: '错误', message: '菜单加载失败！'})
        this.loading = false
      })
    },
    handleTreeNodeClick(node) { // 菜单点击
      // 更新激活的左侧菜单
      this.$store.commit(STORE_APP_MUTATION_TYPES.UPDATE_CURRENT_LEFT_MENU, {id: node.routerName || node.id})
      if (node.children && node.children.length > 0) { // 如果是目录,则打开目录
        this.$set(node, 'open', !node.open)
      } else { // 如果是叶子节点,则执行以下逻辑
        // 判断菜单是否已经打开过,如果已经打开过则切换到对应的标签即可,如果没有打开过则新打开菜单
        let routerName = node.routerName || node.id
        let isOpened = false
        let toRouter = {name: routerName}
        let currentTab = {id: routerName, routers: []}
        let topTabList = this.$store.state.app.topTabList
        for (let i = 0; i < topTabList.length; i++) {
          if (topTabList[i].id === routerName) {
            isOpened = true
            toRouter = util.getDestRouter(topTabList[i])
            currentTab = topTabList[i]
            break
          }
        }
        if (!isOpened) {
          // 新增一个顶部标签
          this.$store.commit(STORE_APP_MUTATION_TYPES.ADD_ONE_TOP_TAB, {id: routerName, name: node.name})
        }
        // 更新currentPage
        this.$store.commit(STORE_APP_MUTATION_TYPES.UPDATE_CURRENT_PAGE, currentTab)
        // 切换路由
        this.$router.push(toRouter)
      }
    },
    treeContainerAutoHeight() { // tree container auto height
      if (this.$el && this.$refs.leftMenuHead) {
        this.treeContainerHeight = this.$el.offsetHeight - this.$refs.leftMenuHead.offsetHeight - 70
        this.$refs.leftMenuScrollBar.update()
        setTimeout(() => {
          this.treeContainerAutoHeight()
        }, 200)
      }
    },
    handleTreeSearchInputFocusAndBlur(focus) { // 菜单搜索框获得焦点时增加样式
      this.treeSearchInputFocus = focus
    },
    searchMenu: _.debounce( // 菜单搜索
      function () {
        if (this.menuSearchInputVal) {
          this.menuOpens = []
        }
        for (let i = 0; i < this.treeData.length; i++) {
          this.searchMenuNode(this.treeData[i])
        }
      },
      500 // 用户输入结束判定延迟时间
    ),
    clearSearchInputVal() {  // 删除菜单搜索框的值
      this.menuSearchInputVal = ''
    },
    searchMenuNode(node) { // 检索菜单，叶子节点有匹配时，父节点才会显示
      let show = false
      if (node.children && node.children.length > 0) {
        for (let i = 0; i < node.children.length; i++) {
          if (this.searchMenuNode(node.children[i])) {
            show = true
          }
        }
      } else {
        show = node.name.indexOf(this.menuSearchInputVal) !== -1
      }
      if (this.menuSearchInputVal) {
        let index = node.routerName || node.id
        this.menuOpens.push(index)
      }
      this.$set(node, 'show', show)
      if (this.menuSearchInputVal) {
        this.$nextTick(_ => {
          this.$set(node, 'open', show)
        })
      }
      return show
    },
    expendTreeNode(node) { // 展开/折叠 菜单
      if (node.children && node.children.length > 0) {
        this.$set(node, 'open', !this.treeAllNodeExpend)
        let index = node.routerName || node.id
        this.menuOpens.push(index)
        for (let i = 0; i < node.children.length; i++) {
          this.expendTreeNode(node.children[i])
        }
      }
    },
    handleTreeExpend() { // 展开/折叠 菜单
      this.menuOpens = []
      for (let i = 0; i < this.treeData.length; i++) {
        if (!this.treeAllNodeExpend) {
          this.expendTreeNode(this.treeData[i])
        }
      }
      this.treeAllNodeExpend = !this.treeAllNodeExpend
    },
    // 切换左侧菜单显示/隐藏
    handleShowLeftMenu(showLeftMenu) {
      this.$store.commit(STORE_APP_MUTATION_TYPES.SET_SHOW_LEFT_MENU, showLeftMenu)
    },
    handleShowIcon() {
      this.handleShowLeftMenu(true)
      this.$refs.searchInput.focus()
    }
  },
  watch: {
    menuSearchInputVal: function () { // 菜单搜索
      this.searchMenu()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/left-menu/left-menu.vue